import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";

/** Props Interface */
interface UseAssignmentReferenceDataProps {
	referenceId: string;
	partnershipId: string;
}

export function useAssignmentReferenceData({
	referenceId,
	partnershipId,
}: UseAssignmentReferenceDataProps) {
	/** Hooks */
	const { organization } = useAuth();

	/** Query */
	const {
		data: assignmentReferenceData,
		isLoading,
		isError,
		refetch,
	} = useQuery({
		queryKey: ["partner", "assignment-reference-bookings", "meta", referenceId],
		queryFn: async () => {
			if (!organization) throw new Error("No organization found");
			const response = await client.organizations[":orgId"].partnerships[
				":partnershipId"
			].timeline.reference[":referenceId"].bookings.meta.$get({
				param: {
					orgId: guardString(organization?.id),
					partnershipId,
					referenceId,
				},
			});
			const data = await responseHandler(response);
			return data;
		},
	});

	return { assignmentReferenceData, isLoading, isError, refetch };
}
